"use strict";

export default {
  inBearbeitung: "4206b7cf-8c0f-4b03-ac66-db3bb6ccbed0",
  // abgeschlossen = "vorläufig freigegeben" = "bearbeitung abgeschlossen"
  abgeschlossen: "a785435f-df65-4e1d-b668-e722d9f44841",
  freigegeben: "5a82cfa7-a9ff-4fd4-aef1-83f803643e31",
  deaktiviert: "61098937-6da0-43c2-b965-cbe69cec2b97"
};
